import { useState } from "react";
import { Dialog, DialogContent } from "./ui/dialog";

// Clickable thumbnail that opens the full image in an elegant centered modal (lightbox).
export const ImageZoom = ({
  src,
  alt = "",
  label,
  testid,
  thumbClassName = "h-9 w-12 object-cover rounded-md border border-slate-200 hover:ring-2 hover:ring-blue-400",
}) => {
  const [open, setOpen] = useState(false);
  if (!src) return null;
  return (
    <>
      <img
        src={src}
        alt={alt}
        data-testid={testid}
        loading="lazy"
        onClick={(e) => { e.stopPropagation(); setOpen(true); }}
        className={`cursor-zoom-in transition ${thumbClassName}`}
      />
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent
          dir="rtl"
          className="max-w-3xl p-0 overflow-hidden bg-slate-900 border-slate-700"
          onClick={(e) => e.stopPropagation()}
          data-testid={testid ? `${testid}-modal` : "image-zoom-modal"}
        >
          <div className="relative">
            <img src={src} alt={alt} className="w-full max-h-[82vh] object-contain bg-slate-900" />
            {label && (
              <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/75 to-transparent px-4 pt-8 pb-3 text-white text-sm font-semibold text-center">
                {label}
              </div>
            )}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
